<div class="content-btn-specs">
    <button (click)="generateFicha()" class="btn-go-specs" mat-button>
        Ver ficha técnica
        <span class="icon_info_orange"> <img src="./assets/img/icon_info_orange.svg" alt="icon_info" /></span>
        <span class="icon_info_white"> <img src="./assets/img/icon_info_white.svg" alt="icon_info" /></span>
    </button>
</div>